import { SimpleGrid, Stack } from "@chakra-ui/react";
import { Heading, Text } from "@/elements";
import { useHeadingVariant, useTextVariant } from "@/theme/hooks/useSectionStyle";
import ReviewCard from "./reviewCard";
import { REVIEW_CONSTANTS } from "./constants";

const CustomerReviewComponent = () => {
  const HeadingVariant = useHeadingVariant();
  const { title, desc, list } = REVIEW_CONSTANTS;
  const textVariant = useTextVariant();
  return (
    <Stack gap={8}>
      <Stack gap={4}>
        <Heading as="h2" variant={HeadingVariant} textAlign={"center"}>
          {title}
        </Heading>
        <Text variant={textVariant} color={"text.100"} textAlign={"center"}>
          {desc}
        </Text>
      </Stack>
      <SimpleGrid columns={{ base: 1, sm: 2 }} gap={{ base: 8, sm: 12, "2xl": 16 }}>
        {list.map((item, index) => (
          <ReviewCard key={index} {...item} />
        ))}
      </SimpleGrid>
    </Stack>
  );
};

export default CustomerReviewComponent;
